export default __webpack_public_path__ + "static/media/play_cards_mockup.66e68720.png";